<template>
  <BreadCrumb PageTitle="Account Settings" />
  <CoverImage />
  <StaffAccountSettings v-if="isStaff" />
  <AccountSettings v-else />
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import CoverImage from "../../components/Generals/CoverImage.vue";
import AccountSettings from "../../components/Generals/AccountSettings/AccountSettings.vue";
import StaffAccountSettings from "../../components/Generals/AccountSettings/StaffAccountSettings.vue";
import { useAuthStore } from "@/stores/auth";

export default defineComponent({
  name: "AccountSettingsPage",
  components: {
    BreadCrumb,
    CoverImage,
    AccountSettings,
    StaffAccountSettings,
  },
  setup() {
    const auth = useAuthStore();
    const isStaff = computed(
      () => !!auth.user?.is_staff || !!auth.user?.customer_id
    );

    return { isStaff };
  },
});
</script>
